import { useMutation } from '@tanstack/react-query'

import { generateVariants } from '../api'

const useGenerateVariantsMutation = () => {
  return useMutation({ mutationFn: generateVariants })
}

export default useGenerateVariantsMutation
